import { AwsConfig } from '../Constants';
import BaseService, { RequestInterface } from '../Base';
import { graphqlOperation } from 'aws-amplify';

class PermissionService extends BaseService {
  constructor() {
    super(AwsConfig.API_CONFIG, 'graphql');
  }

  async listGroupPermissions () {
    const graphQlBody = {
      "query": `{ listGroupPermissions { id name route status } }`
    }

    const params: RequestInterface = {
      body: graphQlBody
    }

    const res = await super.post('', params)
    return res
  }

  async listGroupPermissionsAndGroups (id: any) {
    const groupPermissionsQuery = id ? `getUserGroup (id: ${id}) { id name permissions { group_permission_id rule target_group_id } }` : ``
    const graphQlBody = {
      "query": `{ listGroupPermissions { id name route status } listUserGroups { id name } ${groupPermissionsQuery} }`
    }

    const params: RequestInterface = {
      body: graphQlBody
    }

    const res = await super.post('', params)
    return res
  }

  async createUserGroup (permissions: any) {
    const graphQlBody = `
      mutation createUserGroup ($data: UserGroupInput!) {
        createUserGroup(data: $data)
      }
    `
    const query = graphqlOperation(graphQlBody, { data: permissions })
    const params: RequestInterface = { body: query }
    const res = await super.postGraphQl('', params)

    return res;
  }

  async updateUserGroup (permissions: any) {
    const graphQlBody = `
      mutation updateUserGroup ($data: UserGroupInput!) {
        updateUserGroup(data: $data)
      }
    `
    const query = graphqlOperation(graphQlBody, { data: permissions })
    const params: RequestInterface = { body: query }
    const res = await super.postGraphQl('', params)

    return res;
  }

  async getUserGroupByUser (id: any) {
    const graphQlBody = { "query": `
      { getUserGroupByUser(id: "${id}") {
        id
        alias
        permissions {
          group_permission_id
          rule
          target_group_id
        }
      } }
    `}
    const params: RequestInterface = {
      body: graphQlBody
    }

    const res = await super.post('', params)
    return res
  }
}

export default PermissionService